/** Familles, et ce que chacune donne le droit de faire. */
export const AVATAR_TIERS = ['free', 'account', 'paid'];
/** Combien d'avatars par famille, tel que le dossier public en contient. */
export const AVATAR_COUNTS = { free: 13, account: 4, paid: 4 };
/** Forme d'un identifiant. Le serveur ne valide QUE cela au join. */
export const AVATAR_PATTERN = /^(free|account|paid)_\d{1,2}$/;
export function isAvatarId(value) {
    if (typeof value !== 'string' || !AVATAR_PATTERN.test(value))
        return false;
    const [tier, index] = value.split('_');
    const number = Number.parseInt(index, 10);
    return number >= 1 && number <= AVATAR_COUNTS[tier];
}
export function avatarIds(tier) {
    return Array.from({ length: AVATAR_COUNTS[tier] }, (_, index) => `${tier}_${index + 1}`);
}
/**
 * Un avatar gratuit au hasard.
 *
 * Sert aux joueurs sans compte ET aux bots : un bot est un joueur sans compte,
 * lui donner une forme geometrique la ou tous les autres portent une image le
 * distinguerait pour une mauvaise raison. Son icone robot suffit a le dire.
 */
export function randomFreeAvatar(random = Math.random) {
    const index = Math.min(AVATAR_COUNTS.free, Math.max(1, Math.floor(random() * AVATAR_COUNTS.free) + 1));
    return `free_${index}`;
}
//# sourceMappingURL=avatars.js.map